import { MDBFooter, MDBContainer, MDBCol, MDBRow } from "mdb-react-ui-kit";
import { BsFacebook, BsTwitter, BsInstagram } from "react-icons/bs";

import Logo from "../../../assets/LogoGovernoBranco.svg";
import Sefaz from "../../../assets/LogoSefaz.png";

import '../../../assets/global.css';

import Maps from "../../../images/mapa/map.svg";

export default function Rodape() {
  return (
    <MDBFooter
      style={{ backgroundColor: "#222" }}
      className="text-white text-justify text-lg-justify"
    >
      <MDBContainer className="p-4">
        <MDBRow className="md:flex">
          <MDBCol lg="6" md="12" className="mb-4 mb-md-0">
            <div className="flex">
              <div id="main" className="flex justify-between mt-25">
                <a href="https://paraiba.pb.gov.br/" target="_blank">
                  <img src={Logo} alt="Estado" width={240} />
                </a>
                <a href="https://www.sefaz.pb.gov.br/" target="_blank" className="mt-3">
                  <img src={Sefaz} alt="Sefaz" width={170} />
                </a>
              </div>
            </div>
            <br />
            <br />
            <div className="mt-[-30px]">
            <h3 className="btn text-white m-0 text-lg-justify">
              <b>SECRETARIA DE ESTADO DA FAZENDA</b>
            </h3>
            <br />
            <h3 className="btn text-white m-0 text-lg-justify">
              <b>Escola de Administração Tributária - ESAT</b>
            </h3>
            <br />
            <h3 className="btn text-white m-0 text-justify">
              <b>
                Rua Industrial Abelardo Alvim Gomes Schimmelpfeng, 400 -
                Distrito Industrial
              </b>
            </h3>
            <br />
            <h3 className="btn text-white m-0 text-justify">
              <b>CEP: 58082-014 - João Pessoa - PB</b>
            </h3>
            <br />
            <h3 className="btn text-white m-0 text-justify">
              <b>Fone: {/* <a href="tel:+558332184960">(83) 3218-4960</a>  / */} <a href="tel:+5583993769417">(83) 99376-9417</a> </b>
              <br />  
            </h3>
            <br />
            </div>
            <div>
              <div className="container">
                <section className=" flex mb-2">
                  <a
                    className="md:hover:bg-blue-700 btn-floating m-2 "
                    href="https://www.facebook.com/esat.sefaz.pb"
                    target="_blank"
                    role="button" 
                  >
                    <BsFacebook color="#2584C6" style={{ fontSize: "29px" }}  />
                  </a>

                  <a
                    className="md:hover:bg-blue-700 btn-floating m-2"
                    href="https://twitter.com/esatpb"
                    target="_blank"
                    role="button"
                  >
                    <BsTwitter color="blue" style={{ fontSize: "29px" }} />
                  </a>

                  <a
                    className="md:hover:bg-blue-700 btn-floating m-2"
                    href="https://www.instagram.com/esatpb/"
                    target="_blank"
                    role="button"
                  >
                    <BsInstagram color="#C10396"  style={{ fontSize: "29px" }} />
                  </a>
                </section>
              </div>
              <div className="text-justify p-3 text-white">
                &copy; {new Date().getFullYear()} Copyright:{" "}
                <a
                  className="text-white"
                  href="https://sesat1.sefaz.pb.gov.br/esat/"
                >
                  ESAT
                </a>
              </div>
            </div>
          </MDBCol>
          <MDBCol lg="3" md="5" className="flex sm:ml-[55px] md:mt-20">
            <a
              className="text-white"
              href="https://www.google.com/maps/place/ESAT+-+Escola+de+Administra%C3%A7%C3%A3o+Tribut%C3%A1ria/@-7.1768194,-34.9092504,4436m/data=!3m1!1e3!4m14!1m6!3m5!1s0x7ace99ed7b26811:0xf48c1c85a32fd8a!2sESAT+-+Escola+de+Administra%C3%A7%C3%A3o+Tribut%C3%A1ria!8m2!3d-7.1770275!4d-34.9014394!3m6!1s0x7ace99ed7b26811:0xf48c1c85a32fd8a!8m2!3d-7.1770275!4d-34.9014394!15sCgRlc2F0kgEGc2Nob29s4AEA!16s%2Fg%2F11b6dhm2v1?hl=pt-BR
"
              target="_blank"
            >
              <p className="text-zinc-400" style={{ textDecoration: "none" }}>Localização</p>
              <img className="opacity-60" style={{ width: "100%" }} src={Maps} alt="Mapa" /><br /><br /><br />
            </a>           
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </MDBFooter>
  );
}